import { Box, Stack, Typography } from '@mui/material';
import type { QuotationSummary } from '@/features/operations/types';

/**
 * What the applicant declared, read from the answers stored with the request.
 *
 * Labels come from the answer rows themselves, not from today's configuration, so a request
 * stays readable after the field or option it used is retired from the form. Requests taken
 * before the fields became configurable are normalized to these same answer rows by migration.
 */
export function DeclaredStateDetail({ quotation }: { quotation: QuotationSummary }) {
  if (!quotation.answers.length) {
    return null;
  }

  return (
    <Box>
      <Typography variant="overline" color="text.secondary">
        ESTADO DECLARADO
      </Typography>
      <Stack spacing={0.25}>
        {quotation.answers.map((answer) => (
          <Typography key={answer.id} variant="body2">
            {answer.fieldLabel}: {answer.answerLabel}
          </Typography>
        ))}
      </Stack>
    </Box>
  );
}
